export default __webpack_public_path__ + "static/media/SWT0540.34I-20586_-22455_0.fa527067.jpg";